import { PluginListenerHandle } from '@capacitor/core';

export type KeyboardData = {
    keyboardHeight: number;
};

export interface KeyboardResizeOptions {
    mode: KeyboardResize;
}

export enum KeyboardResize {
    Body = 'body',
    Ionic = 'ionic',
    Native = 'native',
    None = 'none',
}

/**
 * While the following functions are meant to mimic the Capacitor Keyboard plugin, there are several
 * functions not implemented at this time as we are not currently using them, however they could potentially
 * be implemented at a future date if required:
 *  • setAccessoryBarVisibile
 *  • setResizeMode
 *  • getResizeMode
 *  • setScroll
 */

export interface KeyboardPluginInterface {
    /**
     * Get keyboard height
     */
    getKeyboardHeight(): Promise<KeyboardData>;

    /**
     * Show the keyboard
     */
    show(): Promise<void>;

    /**
     * Hide the keyboard
     */
    hide(): Promise<void>;

    /**
     * Check if a hardware keyboard is connected
     *
     * Only supported on iOS
     */
    isHardwareKeyboardConnected(): Promise<{ connected: boolean }>;

    /**
     * Listen for keyboard height
     */
    addListener(
        eventName: 'keyboardHeight',
        listenerFunc: (data: KeyboardData) => void,
    ): Promise<PluginListenerHandle> & PluginListenerHandle;

    /**
     * Listen for when the keyboard will be shown
     */
    addListener(
        eventName: 'keyboardWillShow',
        listenerFunc: (data: KeyboardData) => void,
    ): Promise<PluginListenerHandle>;

    /**
     * Listen for when the keyboard has shown
     *
     */
    addListener(
        eventName: 'keyboardDidShow',
        listenerFunc: (data: KeyboardData) => void,
    ): Promise<PluginListenerHandle>;

    /**
     * Listen for when the keyboard is about to be hidden
     */
    addListener(
        eventName: 'keyboardWillHide',
        listenerFunc: (data: KeyboardData) => void,
    ): Promise<PluginListenerHandle>;

    /**
     * Listen for when the keyboard has hidden
     */
    addListener(
        eventName: 'keyboardDidHide',
        listenerFunc: (data: KeyboardData) => void,
    ): Promise<PluginListenerHandle>;

    /**
     * Remove all listeners
     */
    removeAllListeners(): Promise<void>;
}
